<template lang="pug">
filter-detail-container(:title="title" :save-mode="false" @back="back" @clear="clear" @save="save")
  template(v-slot:body)
    .pa-6
      div {{ description }}
      yc-select.mt-4(v-model="condition" :items="options")
      yc-text-field.mt-4(label="Select date in calendar below" v-model="dates" disabled)
      v-card.mt-8(outlined)
        yc-date-picker(:parentDate.sync="dates" :range="condition === 'between'")
</template>

<script>
import FilterDetailContainer from '@/components/connect/FilterDetailContainer.vue'

export default {
  props: {
    filter: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: 'Filter date'
    },
    description: {
      type: String,
      default: 'Filter appointment made on:'
    }
  },
  components: { FilterDetailContainer },
  data: () => ({
    condition: 'before',
    dates: null,
    options: [
      { id: 'before', label: 'Before' },
      { id: 'after', label: 'After' },
      { id: 'exact', label: 'Exact date' },
      { id: 'between', label: 'In between' }
    ],
  }),
  created () {
    const { before, after, exact, between } = this.filter
    if (before) {
      this.condition = 'before'
      this.dates = before
    }
    if (after) {
      this.condition = 'after'
      this.dates = after
    }
    if (exact) {
      this.condition = 'exact'
      this.dates = exact
    }
    if (between) {
      this.condition = 'between'
      this.dates = [between.start, between.end]
    }
  },
  methods: {
    save () {
      const filter = this.getFilterData()
      this.$emit('update:filter', filter)
      this.back()
    },
    getFilterData () {
      switch (this.condition) {
        case 'before':
          return { before: this.dates }
        case 'after':
          return { after: this.dates }
        case 'exact':
          return { exact: this.dates }
        case 'between':
          return {
            between: {
              start: this.dates[0],
              end: this.dates[1] ?? this.dates[0]
            }
          }
        default:
          return {}
      }
    },
    back () {
      this.$emit('onBack')
    },
    clear () {
      this.dates = null
    }
  }
}
</script>